import { REDUX_ACTIONS } from "constants/constants";

export const createCartUniqueId = () => ({
  type: REDUX_ACTIONS.CREATE_CART_UNIQUE_ID,
  payload: new Date().getTime(),
});

export const resetCartUnqiueId = () => ({
  type: REDUX_ACTIONS.RESET_CART_UNIQUE_ID,
});
